module.exports = __webpack_public_path__ + "img/banner2.22af7b02.jpg";